<template>
    <div class="pop-wrap" v-if="talent">
      <ul class="pop-list">
        <li v-if="talent.phone"><span class="label">联系电话</span><a class="green" :href="'tel:'+talent.phone">{{talent.phone}}<span class="fr">呼叫</span></a></li>
        <li v-if="talent.email"><span class="label">联系邮箱</span><a class="green" :href="'mailto:'+talent.email">{{talent.email}}</a></li>
      </ul>
      <div class="space"></div>
      <div class="close" @click="cancel">取消</div>
    </div>
</template>

<script>
export default {
  name: "concatTalent",
  props: {
    talent: {}
  },
  data() {
    return {
    }
  },
  watch:{

  },
  methods: {
    cancel(){
      this.$emit('close');
    }
  },
  created() {
    
  }
};
</script>